import { Formik } from 'formik';
import { useEffect } from 'react';
import { Flex } from 'reflexbox';

import { useQueryParameters } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Spinner } from '@treams/treams-ui';

import BareLayout from '../../../../../../src/packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from '../../components/authentication/PublicForm';

export default function SSO() {
	const params = useQueryParameters(['provider_id']);
	const query = graphql.useSingleSignOnsQuery();

	const singleSignOns = query.data?.singleSignOns;
	const requested = params['provider_id']
		? singleSignOns?.find((provider) => provider.identityProvider.id === params['provider_id'])
		: undefined;

	const url = (requested ?? singleSignOns?.[0])?.url;
	useEffect(() => {
		if (!url) {
			return;
		}

		window.location.href = url;
	}, [url]);

	return (
		<BareLayout>
			<Formik initialValues={{}} onSubmit={() => {}}>
				<PublicForm>
					<Flex alignItems="center" justifyContent="center" height={200}>
						<Spinner />
					</Flex>
				</PublicForm>
			</Formik>
		</BareLayout>
	);
}
